import Icon from "@react-native-vector-icons/material-design-icons/static";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import Button from "../Button";
import { FlatCard } from "../Cards/FlatCard";

export type FreeContentBannerProps = {
	title: string;
	body: string;
	ctaLabel: string;
	onPress: () => void;
};

export const FreeContentBanner = ({
	title,
	body,
	ctaLabel,
	onPress,
}: FreeContentBannerProps) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	return (
		<FlatCard style={{ backgroundColor: theme.colors.secondaryContainer }}>
			<Box
				flexDirection="row"
				alignItems="center"
				gap={16}
				padding={16}
				flexWrap="wrap"
			>
				<Icon
					name="star-four-points-outline"
					size={24}
					color={theme.colors.primary}
				/>
				<Box flex={1} gap={4} style={{ minWidth: 200 }}>
					<Text variant="titleMedium">{title}</Text>
					<Text
						variant="bodyMedium"
						style={{ color: theme.colors.onSurfaceVariant }}
					>
						{body}
					</Text>
				</Box>
				<Box
					alignItems="flex-end"
					style={isMobile ? { width: "100%" } : undefined}
				>
					<Button mode="contained" onPress={onPress}>
						{ctaLabel}
					</Button>
				</Box>
			</Box>
		</FlatCard>
	);
};
